import { List } from "immutable"
import { AsyncState, HttpResult, httpResult, loadingAsyncState } from "widgets-for-react"
import { Breadcrumbs, CMSFooterItem, CMSLanguageMenuItem, CMSLoaderState, CMSMenuItem } from "../cmsPage.state"
// import { CMSFooterItem, CMSLoaderState, CMSMenuItem } from "../cmsState"
import { linkWrapper } from "../utils/link"
import i18next from "i18next"
import { pageheaderLargeSrc, pageheaderLargeSrcDesktop, pageheaderLargeSrcSet, pageheaderLargeSrcSetDesktop, pageheaderLargeSrcSetTablet, pageheaderLargeSrcTablet, pageheaderSmallSrc, pageheaderSmallSrcSet } from "./utils/imageSizes"
import { parseDrupalImageUrls } from "./utils/modernImage"
import { getHomeHeader, getPageHeader } from "./api.headers"
import { StoryPageDatasheetState } from "../customPages/storyPage/storyPage.state"

export namespace Drupal {

  export const getHomePage: (
    lang: string,
  ) => Promise<
    HttpResult<CMSLoaderState>
  > = async (lang) => {

    try {
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/drupal/getHomePage`, {
        method: 'get', credentials: 'include', headers: headers
      })
      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()

      type Breadcrumbs = List<{
        url: string;
        title: string;
      }>

      let bread: Breadcrumbs = List([])

      const getHeader = (json: any) => {
        return getHomeHeader(json)
      }

      const pageKind = json?.[0]?.type?.[0]?.target_id || ''
      const nodeId = json?.[0]?.nid?.[0]?.value || ""

      return {
        kind: 'result',
        status: 200,
        value: {
          blocks: json[0].field_page_content,
          pageData: {
            header: getHeader(json),
            page: {
              kind: pageKind,
              language: lang,
              nodeId: nodeId,
            },
            metadata: json[0].metatag ? json[0].metatag.value ? json[0].metatag.value : json[0].metatag : {},
            breadcrumbs: bread,
          }
        } as CMSLoaderState
      }
    } catch (e) {

      console.error("Error when fetching homepage")
      console.error(e)

      return {
        kind: 'failed',
        status: 500
      }
    }
  }

  export const getPage: (
    lang: string,
    slug: string
  ) => Promise<
    HttpResult<CMSLoaderState>
  > = async (lang, slug) => {
    try {
      if (slug == "" || slug == undefined) {
        slug = "/"
      }
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/drupal/getPage?slug=${slug}`, {
        method: 'get', credentials: 'include', headers: headers
      })
      if (!res.ok) {
        if (res.status === 303) {
          const json = await res.json()
          window.location = json.location
          return {
            kind: "failed",
            status: 303
          }
        }

        throw Error(res.statusText)
      }
      let json = await res.json()

      let breadcrumb: Breadcrumbs = List([])

      const pageKind = json.type[0]?.target_id || ''
      const nodeId = json.nid[0]?.value || ""
      const getHeader = (pageKind: string, json: any) => { return getPageHeader(json) }

      return {
        kind: 'result',
        status: 200,
        value: {
          blocks: json.field_page_content,
          pageData: {
            header: getHeader(pageKind, json),
            page: {
              kind: pageKind,
              language: lang,
              nodeId: nodeId,
            },
            tableOfContents: !!json.field_table_of_contents?.[0]?.value,
            metadata: json.metatag ? json.metatag.value ? json.metatag.value : json.metatag : {},
            breadcrumbs: breadcrumb,
          }
        } as CMSLoaderState
      }
    } catch (e) {

      console.error("Error when fetching page", slug)
      console.error(e)

      return {
        kind: 'failed',
        status: 500
      }
    }
  }

  export const getStoryPageDatasheet: (
    lang: string,
    slug: string
  ) => Promise<
    HttpResult<StoryPageDatasheetState>
  > = async (lang, slug) => {
    try {
      if (slug == "" || slug == undefined) {
        slug = "/"
      }
      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/drupal/getPage?slug=${slug}`, {
        method: 'get', credentials: 'include', headers: headers
      })
      if (!res.ok) {
        if (res.status === 303) {
          const json = await res.json()
          window.location = json.location
          return {
            kind: "failed",
            status: 303
          }
        }

        throw Error(res.statusText)
      }
      let json = await res.json()
      
      return {
        kind: 'result',
        status: 200,
        value: {
          name: json.field_name[0]?.value || undefined,
          age: json.field_age[0]?.value || undefined,
          disease: json.field_rheumatic_disease[0]?.value || undefined
        } as StoryPageDatasheetState
      }
    } catch (e) {

      console.error("Error when fetching page", slug)
      console.error(e)

      return {
        kind: 'failed',
        status: 500
      }
    }
  }


  export const getPreviewPage: (nodeId: number, revisionId: string, previewToken: string) => Promise<HttpResult<CMSLoaderState>> = async (
    nodeId: number,
    revisionId: string,
    previewToken: string,
  ) => {
    try{
    let headers = new Headers()
    headers.append('content-type', 'application/json')
    headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

    let res = await fetch(`/api/drupal/preview/${nodeId}/${revisionId}?token=${previewToken}`, {
      method: 'get', credentials: 'include', headers: headers
    })

    if(!res.ok) throw Error(res.statusText)

    const json = await res.json()
    if (json == undefined) throw Error

    let breadcrumb: Breadcrumbs = List([])

    let headerTitle = json.title[0]?.value ?? undefined
    let headerIntroduction = json.field_introduction[0]?.value ?? undefined

    let headerPrimaryLink = json.field_links[0]
    let headerSecondaryLink = json.field_links[1]

    const fieldMediaImage = json.field_introduction_image[0]?.target?.field_media_image[0]
    const headerImageSize = json.field_introduction_imagesiz ? json.field_introduction_imagesiz[0]?.value == true ? 'large' : 'small' : 'small'
    const headerImage = fieldMediaImage
      ? parseDrupalImageUrls(
          fieldMediaImage,
          undefined,
          headerImageSize == 'small' ? pageheaderSmallSrcSet : pageheaderLargeSrcSet,
          headerImageSize == 'small' ? pageheaderSmallSrc : pageheaderLargeSrc
        )?.image
      : undefined
    const headerImageTablet = fieldMediaImage
      ? parseDrupalImageUrls(
          fieldMediaImage,
          undefined,
          pageheaderLargeSrcSetTablet,
          pageheaderLargeSrcTablet
        )?.image
      : undefined
    const headerImageDesktop = fieldMediaImage
      ? parseDrupalImageUrls(
          fieldMediaImage,
          undefined,
          pageheaderLargeSrcSetDesktop,
          pageheaderLargeSrcDesktop
        )?.image
      : undefined

    const linkPrimary =
      headerPrimaryLink &&
        headerPrimaryLink.processed_url &&
        headerPrimaryLink.title
        ? linkWrapper({
          url: headerPrimaryLink.processed_url,
          title: headerPrimaryLink.title,
          anchor: headerPrimaryLink.options?.attributes?.id
        }) : undefined

    const linkSecondary =
      headerSecondaryLink &&
        headerSecondaryLink.processed_url &&
        headerSecondaryLink.title
        ? linkWrapper({
          url: headerSecondaryLink.processed_url,
          title: headerSecondaryLink.title,
          anchor: headerSecondaryLink.options?.attributes?.id
        }) : undefined

    return {
      kind: 'result',
      status: 200,
      value: {
        // blocks: blocks.filter((b: any) => b.blockName != "vidda/header"),
        blocks: json.field_page_content,
        pageData: {
          header: {
            kind: 'normal',
            pageTitle: headerTitle,
            pageIntro: headerIntroduction,
            linkPrimary: linkPrimary,
            linkSecondary: linkSecondary,
            image: headerImage,
            imageSize: headerImageSize,
            imageSource: headerImageSize == 'small' ? undefined : headerImageTablet && headerImageDesktop ? [
              {
                  imageProportions: {
                      width: '1920',
                      height: '500',
                      sizes: '100vw',
                      media: '(min-width: 1280px)',
                  },
                  image: headerImageDesktop
              },
              {
                imageProportions: {
                    width: '1280',
                    height: '500',
                    sizes: '100vw',
                    media: '(min-width: 640px)',
                },
                image: headerImageTablet
              }
            ] : [],
          },
          page: {
            kind: '',
            // node: res as any,
            language: 'en'
          },
          metadata: json.metatag ? json.metatag.value ? json.metatag.value : json.metatag : {},
          breadcrumbs: breadcrumb,
        }
      } as CMSLoaderState
    }
  } catch (e) {
    console.error(`Error when fetching page: /api/drupal/preview/${nodeId}/${revisionId}`)
    console.error(JSON.stringify(e))

    return {
      kind: 'failed',
      status: 500
    }
    }
  }

  export const getLanguages = async (): Promise<HttpResult<Array<CMSLanguageMenuItem>>> => {
    return  httpResult.success([])
  }



  export const getMainMenu: (lang: string,slug: string) => Promise<HttpResult<Array<CMSMenuItem>>> =
    async (lang, slug) => menuRequest(`/api/drupal/getMenu`)

  export const getTopMenu: (lang: string) => Promise<HttpResult<Array<CMSMenuItem>>> =
    async (lang) => menuRequest(`/api/drupal/getTopMenu`)


  const menuRequest: (endpoint:string) => Promise<HttpResult<Array<CMSMenuItem>>> =
  async (endpoint) => {
    try {

      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(endpoint, {
        method: 'get', credentials: 'include', headers: headers
      })

      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()

      const menuItems = parseMenuItems(json)

      return {
        kind: 'result',
        status: 200,
        value: menuItems as CMSMenuItem[]
      }
    } catch (e) {

      console.error(`Error when fetching menu at ${endpoint}`)
      console.error(JSON.stringify(e))

      return {
        kind: 'failed',
        status: 500
      }
    }
  }


  const parseMenuItems: (json: any) => CMSMenuItem[] = (json) =>
    json.map((item: any, index: number) => {

      let children = item.below ? item.below.map((child: any, index: number) => {
        return ({
          PageId: index,
          Title: child.title,
          Weight: child.weight,
          Url: '/' + child.alias,
          ShowChildren: false,
        }) as CMSMenuItem
      }) : []

      return ({
        PageId: index,
        Title: item.title,
        Weight: item.weight,
        Url: item.relative,
        ShowChildren: false,
        Children: children

      }) as CMSMenuItem
    })


  export const getCopyright: (
    lang: string,
  ) => Promise<
    HttpResult<Array<CMSFooterItem>>
  > = async (lang) => {

    try {

      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/drupal/getFooter`, {
        method: 'get', credentials: 'include', headers: headers
      })

      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()

      const footerItems = json.map((item: any, index: number) => {

        let children = item.below ? item.below.map((child: any, index: number) => {
          return ({
            PageId: index,
            Title: child.title,
            Weight: child.weight,
            Url: child.alias,
            ShowChildren: false,
            Column: ''
          }) as CMSFooterItem
        }) : []

        return ({
          PageId: index,
          Title: item.title,
          Weight: item.weight,
          Url: item.alias,
          ShowChildren: false,
          Children: children,
        }) as CMSFooterItem
      })

      return {
        kind: 'result',
        status: 200,
        value: footerItems as CMSFooterItem[]
      }
    } catch (e) {

      console.error("Error when fetching menu")
      console.error(JSON.stringify(e))

      return {
        kind: 'failed',
        status: 500
      }
    }
  }

  export const getFooter: (
    lang: string,
  ) => Promise<
    HttpResult<Array<CMSFooterItem>>
  > = async (lang) => {

    try {

      let headers = new Headers()
      headers.append('content-type', 'application/json')
      headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

      let res = await fetch(`/api/drupal/getFooter`, {
        method: 'get', credentials: 'include', headers: headers
      })

      if (!res.ok) throw Error(res.statusText)
      let json = await res.json()

      const footerItems = json.map((item: any, index: number) => {

        let children = item.below ? item.below.map((child: any, index: number) => {
          return ({
            PageId: index,
            Title: child.title,
            Weight: child.weight,
            Url: child.external ? child.absolute : '/' + child.alias,
            ShowChildren: false,
            Column: ''
          }) as CMSFooterItem
        }) : []

        return ({
          PageId: index,
          Title: item.title,
          Weight: item.weight,
          Url: item.external ? item.absolute : '/' + item.alias,
          ShowChildren: false,
          Children: children,
        }) as CMSFooterItem
      })

      return {
        kind: 'result',
        status: 200,
        value: footerItems as CMSFooterItem[]
      }
    } catch (e) {

      console.error("Error when fetching menu")
      console.error(JSON.stringify(e))

      return {
        kind: 'failed',
        status: 500
      }
    }
  }

  // export const getBreadcrumbs: (
  //   lang: string,
  //   slug: string
  // ) => Promise<
  //   HttpResult<{title:string, url:string}[]>
  // > = async (lang, slug) => {

  //   try {

  //     let headers = new Headers()
  //     headers.append('content-type', 'application/json')
  //     headers.append('X-XSRF-TOKEN', (document.getElementsByName("__RequestVerificationToken")[0] as any).value)

  //     let res = await fetch(`/api/drupal/getBreadcrumbs?slug=${slug}`, {
  //       method: 'get', credentials: 'include', headers: headers
  //     })

  //     if (!res.ok) throw Error(res.statusText)
  //     let json = await res.json()

  //     return {
  //       kind: 'result',
  //       status: 200,
  //       value: json
  //     }
  //   } catch (e) {

  //     console.error("Error when fetching getBreadcrumbs")
  //     console.error(JSON.stringify(e))

  //     return {
  //       kind: 'failed',
  //       status: 500
  //     }
  //   }
  // }






















  export const loadHomePage: (
    slug: string
  ) => AsyncState<CMSLoaderState> = (
    slug
  ) => {
      return loadingAsyncState(() => getHomePage('en'))
    }


  export const loadPage: (
    slug: string
  ) => AsyncState<CMSLoaderState> = (
    slug
  ) => {
      return loadingAsyncState(() => getPage('en', slug))
    }

  export const loadPreviewPage: (
    nodeId:number,
    revisionId:string,
    previewToken: string
  ) => AsyncState<CMSLoaderState> = (
    nodeId, revisionId, previewToken
  ) => {
    return loadingAsyncState(() => getPreviewPage(nodeId, revisionId, previewToken))
  }

  export const loadMenu: (
    slug: string
  ) => AsyncState<CMSMenuItem[]> = (
    slug
  ) => {
      return loadingAsyncState(() => getMainMenu('en', ''))
    }

}
